import React from "react";
import { withRouter } from "react-router-dom";
import { view } from "react-easy-state";
import { isMobile } from "react-device-detect";
import { Progress, Button, Icon, Typography, Tooltip, Tabs } from "antd";

import AskDoubt from "components/pages/students/AskDoubt";

const scrollToView = (elementId) => {
  const element = document.getElementById(elementId);
  if (!element) return;
  element.scrollIntoView({ behavior: "smooth" });
  // window.scrollBy(0, -55)
};

const Questionnaires = ({
  questionnaires,
  renderShowQuestionnaireButton,
  questionType,
}) => {
  return (
    <div className="course-section-list">
      <div className="section-box">
        <ul>
          {questionnaires.map((questionnaire) => {
            return (
              <React.Fragment key={questionnaire.id}>
                <li className="lecture">
                  {false && (
                    <div className="lecture-progress">
                      <Progress
                        type="circle"
                        strokeWidth={20}
                        percent={questionnaire.userProgress}
                        width={20}
                        showInfo={false}
                      />
                    </div>
                  )}
                  <div className="lecture-name">
                    <div
                      style={{
                        width: "calc(100% - 36px)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon type="copy" style={{ marginRight: 10 }} />
                      <Tooltip title={questionnaire.name}>
                        <Typography.Text ellipsis style={{ width: "100%" }}>
                          {questionnaire.name}
                        </Typography.Text>
                      </Tooltip>
                    </div>
                    {renderShowQuestionnaireButton(questionnaire, questionType)}
                  </div>
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

class ChapterDetails extends React.Component {
  handleStartVideo = (videoId) => {
    const { chapter } = this.props;
    this.props.history.push(`/chapters/${chapter.id}/videos/${videoId}`);
  };

  handleShowNote = (noteId) => {
    const { chapter } = this.props;
    this.props.history.push(`/chapters/${chapter.id}/notes/${noteId}`);
  };

  handleShowQuestionnaire = (questionnaire, questionType) => {
    const { chapter } = this.props;

    this.props.history.push(
      `/chapters/${chapter.id}/questionnaires/${questionnaire}/start-${questionType}`
    );
  };

  goBack = () => {
    const { subject } = this.props.chapter;
    this.props.history.push(`/subjects/${subject.id}/chapters`);
    // TODO: should be redirected to subject page of this chapter
    // this.props.history.push(`/courses`)
  };

  renderSidebar() {
    if (isMobile) return;

    const { chapter, match } = this.props;
    if (!chapter) return;

    return (
      <div className="course-detail-sider fixed">
        <div className="back-button" onClick={this.goBack}>
          <Icon type="arrow-left" /> Back
        </div>
        <div className="course-image">
          <img src={chapter.image_url} alt={chapter.name} />
        </div>
        <div className="course-name">
          <h3>{chapter.name}</h3>
        </div>
        <div className="course-progress">
          {false && (
            <Progress
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
              percent={chapter.userProgress}
              strokeWidth={12}
              style={{ margin: "15px 0px" }}
            />
          )}
        </div>
        <div className="menu-list">
          <Button type="link" onClick={() => scrollToView("videos")}>
            <Icon type="video-camera" /> <span>Videos</span>
          </Button>
          {chapter.notes && chapter.notes.length > 0 && (
            <Button type="link" onClick={() => scrollToView("notes")}>
              <Icon type="copy" /> <span>Notes</span>
            </Button>
          )}

          {chapter.questionnaires && chapter.questionnaires.length > 0 && (
            <Button type="link" onClick={() => scrollToView("tests")}>
              <Icon type="question-circle" /> <span>Practice Questions</span>
            </Button>
          )}
          <AskDoubt
            chapterId={match.params.chapterId}
            hideSubjectInput={true}
            buttonText={
              <React.Fragment>
                <Icon type="info-circle" /> <span>Ask a doubt</span>
              </React.Fragment>
            }
            buttonType="link"
            buttonStyle={{
              position: "initial",
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </div>
      </div>
    );
  }

  renderStartVideoButton(video) {
    if (isMobile) {
      return (
        <Button
          type="primary"
          shape="circle"
          icon="right"
          onClick={() => this.handleStartVideo(video.id)}
        />
      );
    }

    return (
      <Button type="primary" onClick={() => this.handleStartVideo(video.id)}>
        Start
      </Button>
    );
  }

  renderShowNoteButton(note) {
    if (isMobile) {
      return (
        <Button
          type="primary"
          shape="circle"
          icon="right"
          onClick={() => this.handleShowNote(note.id)}
        />
      );
    }

    return (
      <Button type="primary" onClick={() => this.handleShowNote(note.id)}>
        View
      </Button>
    );
  }

  renderShowQuestionnaireButton = (questionnaire, questionType) => {
    if (isMobile) {
      return (
        <Button
          type="primary"
          shape="circle"
          icon="right"
          onClick={() =>
            this.handleShowQuestionnaire(questionnaire.id, questionType)
          }
        />
      );
    }

    return (
      <Button
        type="primary"
        onClick={() =>
          this.handleShowQuestionnaire(questionnaire.id, questionType)
        }
      >
        Practice
      </Button>
    );
  };

  renderVideos() {
    const { chapter } = this.props;
    if (!chapter) return;
    if (!chapter.videos) return;
    if (chapter.videos.length === 0) return;
    return (
      <React.Fragment>
        <div id="videos" style={{ position: "absolute", top: -55 }}></div>
        <div>
          {!isMobile && <h2>Videos</h2>}
          {false && (
            <div className="next-lecture-button-box">
              <Button type="primary" size="large">
                Start next video <Icon type="right" />
              </Button>{" "}
              {!isMobile && <span>New Lecture 1</span>}
            </div>
          )}
          <div className="course-section-list">
            <div className="section-box">
              <ul>
                {chapter.videos.map((video) => (
                  <React.Fragment key={video.id}>
                    <li className="lecture">
                      {false && (
                        <div className="lecture-progress">
                          <Progress
                            type="circle"
                            strokeWidth={20}
                            percent={video.userProgress}
                            width={20}
                            showInfo={false}
                          />
                        </div>
                      )}
                      <div className="lecture-name">
                        <div
                          style={{
                            width: "calc(100% - 36px)",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            type="video-camera"
                            style={{ marginRight: 10 }}
                          />
                          <Tooltip title={video.name}>
                            <Typography.Text ellipsis style={{ width: "100%" }}>
                              {video.name}
                            </Typography.Text>
                          </Tooltip>
                        </div>
                        {this.renderStartVideoButton(video)}
                      </div>
                    </li>
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderNotes() {
    const { chapter } = this.props;
    if (!chapter.notes) return;
    if (chapter.notes.length === 0) return;

    return (
      <div id="notes">
        {!isMobile && <h2>Notes</h2>}
        <div className="course-section-list">
          <div className="section-box">
            <ul>
              {chapter.notes.map((note) => (
                <React.Fragment key={note.id}>
                  <li className="lecture">
                    {false && (
                      <div className="lecture-progress">
                        <Progress
                          type="circle"
                          strokeWidth={20}
                          percent={note.userProgress}
                          width={20}
                          showInfo={false}
                        />
                      </div>
                    )}
                    <div className="lecture-name">
                      <div
                        style={{
                          width: "calc(100% - 36px)",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon type="copy" style={{ marginRight: 10 }} />
                        <Tooltip title={note.name}>
                          <Typography.Text ellipsis style={{ width: "100%" }}>
                            {note.name}
                          </Typography.Text>
                        </Tooltip>
                      </div>
                      {this.renderShowNoteButton(note)}
                    </div>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderPracticeQuestions = () => {
    const { chapter } = this.props;
    const objectiveQuestionnaires = chapter.questionnaires.filter(
      (q) => q.status === "active" && q.total_objective_questions_count > 0
    );
    const subjectiveQuestionnaires = chapter.questionnaires.filter(
      (q) => q.status === "active" && q.total_subjective_questions_count > 0
    );

    if (!chapter.questionnaires) return;

    return (
      <div id="tests">
        {!isMobile && <h2>Practice Questions</h2>}

        <ul style={{ padding: 0, listStyleType: "none" }}>
          {objectiveQuestionnaires.length > 0 && (
            <li>
              <h3>Objective</h3>
            </li>
          )}
          <Questionnaires
            questionnaires={objectiveQuestionnaires}
            questionType={"objective"}
            renderShowQuestionnaireButton={this.renderShowQuestionnaireButton}
          />
          {subjectiveQuestionnaires.length > 0 && (
            <li>
              <h3>Subjective</h3>
            </li>
          )}
          <Questionnaires
            questionnaires={subjectiveQuestionnaires}
            questionType={"subjective"}
            renderShowQuestionnaireButton={this.renderShowQuestionnaireButton}
          />
        </ul>
      </div>
    );
  };

  // renderPracticeSubjectiveQuestions() {
  //   const { chapter } = this.props
  //   const questionnaires = chapter.questionnaires.filter(q => (q.status === "active") && q.total_subjective_questions_count > 0)

  //   if (!questionnaires) return
  //   if (questionnaires.length === 0) return

  //   return (
  //     <div id="tests">
  //       {!isMobile && <h2>Practice Subjective Questions</h2>}
  //       <Questionnaires
  //         questionnaires={questionnaires}
  //         questionType={"subjective"}
  //         renderShowQuestionnaireButton={this.renderShowQuestionnaireButton}
  //       />
  //     </div>
  //   )
  // }

  render() {
    return (
      <div className="course-detail">
        {this.renderSidebar()}
        <div className="course-detail-main  with-fixed-sider">
          {isMobile && (
            <Tabs defaultActiveKey="videos">
              <Tabs.TabPane tab="Videos" key="videos">
                {this.renderVideos()}
              </Tabs.TabPane>
              <Tabs.TabPane tab="Notes" key="notes">
                {this.renderNotes()}
              </Tabs.TabPane>
              <Tabs.TabPane tab="Questions" key="questions">
                {this.renderPracticeQuestions()}
              </Tabs.TabPane>
            </Tabs>
          )}
          {!isMobile && this.renderVideos()}
          {!isMobile && this.renderNotes()}
          {!isMobile && this.renderPracticeQuestions()}
        </div>
      </div>
    );
  }
}

export default withRouter(view(ChapterDetails));
